"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

var ArticleList_1 = __importDefault(require("./ArticleList"));

var CalendarEventList_1 = __importDefault(require("./CalendarEventList"));

var DangerousSource_1 = __importDefault(require("./DangerousSource"));

var Document_1 = __importDefault(require("./Document"));

var External_1 = __importDefault(require("./External"));

var Actsection_1 = __importDefault(require("./Actsection"));

var FAQ_1 = __importDefault(require("./FAQ"));

var FormattedText_1 = __importDefault(require("./FormattedText"));

var ImageAd_1 = __importDefault(require("./ImageAd"));

var Multiblock_1 = __importDefault(require("./Multiblock"));

var Partners_1 = __importDefault(require("./Partners"));

var Persons_1 = __importDefault(require("./Persons"));

var Photo_1 = __importDefault(require("./Photo"));

var PhotoGallery_1 = __importDefault(require("./PhotoGallery"));

var RotatingArticle_1 = __importDefault(require("./RotatingArticle"));

var SectionList_1 = __importDefault(require("./SectionList"));

var Social_1 = __importDefault(require("./Social"));

var SportRecords_1 = __importDefault(require("./SportRecords"));

var Table_1 = __importDefault(require("./Table"));

var Television_1 = __importDefault(require("./Television"));

var Video_1 = __importDefault(require("./Video"));

var Voting_1 = __importDefault(require("./Voting"));

var styled_components_1 = __importStar(require("styled-components"));

var polished_1 = require("polished");

var styles_1 = require("../../common/styles");

var WidgetWrapper = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: auto;\n  margin-bottom: ", ";\n  min-height: 0; // react-slick blbne, ked je umiestneny do flexboxu - toto to riesi\n  min-width: 0; // react-slick blbne, ked je umiestneny do flexboxu - toto to riesi\n  ", "\n  ", "\n"], ["\n  margin: auto;\n  margin-bottom: ", ";\n  min-height: 0; // react-slick blbne, ked je umiestneny do flexboxu - toto to riesi\n  min-width: 0; // react-slick blbne, ked je umiestneny do flexboxu - toto to riesi\n  ", "\n  ", "\n"])), function (_a) {
  var theme = _a.theme,
      hasBottomGutter = _a.hasBottomGutter;
  return hasBottomGutter && polished_1.em(theme.grid.gutterWidth * 2.5);
}, function (_a) {
  var hasAppPadding = _a.hasAppPadding;
  return hasAppPadding && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        padding: 0 ", "px;\n      "], ["\n        padding: 0 ", "px;\n      "])), function (_a) {
    var theme = _a.theme;
    return theme.app.padding;
  });
}, function (_a) {
  var maxWidth = _a.maxWidth;

  if (maxWidth > 0) {
    return styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        max-width: ", ";\n      "], ["\n        max-width: ", ";\n      "])), polished_1.em(maxWidth));
  }

  return '';
});
var noAppPadding = {
  television: 1,
  video: 1,
  articlelist: 1,
  multiblock: 1
};
var smallWidthWidgets = {
  text: 1,
  document: 1,
  sectionlist: 1
};
var mediumWidthWidgets = {
  actsection: 1,
  externalArticle: 1,
  imagead: 1,
  livestream: 1,
  photo: 1,
  photogallery: 1,
  sportnetvideo: 1,
  table: 1,
  voting: 1,
  youtube: 1
};

function getMaxWidth(widgetType) {
  if (widgetType in smallWidthWidgets) {
    return styles_1.TEXT_BLOCK_MAX_WIDTH;
  }

  if (widgetType in mediumWidthWidgets) {
    return 870;
  }

  return 0;
} // @TODO prerobit na mapu


var C = function C(_a) {
  var widget = _a.widget,
      renderLink = _a.renderLink,
      renderEmpty = _a.renderEmpty;

  function render() {
    switch (widget.type) {
      case 'text':
        return react_1["default"].createElement(FormattedText_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'articlelist':
        return react_1["default"].createElement(ArticleList_1["default"], {
          data: widget,
          renderLink: renderLink,
          renderEmpty: renderEmpty
        });

      case 'actsection':
        return react_1["default"].createElement(Actsection_1["default"], {
          data: widget,
          renderLink: renderLink,
          renderEmpty: renderEmpty
        });

      case 'calendarEventList':
        return react_1["default"].createElement(CalendarEventList_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'sectionlist':
        return react_1["default"].createElement(SectionList_1["default"], {
          data: widget,
          renderLink: renderLink,
          renderEmpty: renderEmpty
        });

      case 'dangerousSource':
        return react_1["default"].createElement(DangerousSource_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'photo':
        return react_1["default"].createElement(Photo_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'photogallery':
        return react_1["default"].createElement(PhotoGallery_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'table':
        return react_1["default"].createElement(Table_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'video':
        return react_1["default"].createElement(Video_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'sportnetvideo':
      case 'livestream':
      case 'youtube':
        return react_1["default"].createElement(Video_1["default"], {
          data: {
            type: 'video',
            url: widget.uri
          },
          renderEmpty: renderEmpty
        });

      case 'imagead':
        return react_1["default"].createElement(ImageAd_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'multiblock':
        return react_1["default"].createElement(Multiblock_1["default"], {
          data: widget,
          renderLink: renderLink,
          renderEmpty: renderEmpty
        });

      case 'rotatingArticle':
        return react_1["default"].createElement(RotatingArticle_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'social':
        return react_1["default"].createElement(Social_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'voting':
        return react_1["default"].createElement(Voting_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'partners':
        return react_1["default"].createElement(Partners_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'persons':
        return react_1["default"].createElement(Persons_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'faq':
        return react_1["default"].createElement(FAQ_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'document':
        return react_1["default"].createElement(Document_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'externalArticle':
        return react_1["default"].createElement(External_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'television':
        return react_1["default"].createElement(Television_1["default"], {
          data: widget,
          renderLink: renderLink
        });

      case 'sportRecords':
        return react_1["default"].createElement(SportRecords_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      default:
        return null;
    }
  }

  var content = render();

  if (!content) {
    return null;
  }

  return react_1["default"].createElement(WidgetWrapper, {
    maxWidth: getMaxWidth(widget.type),
    hasAppPadding: !(widget.type in noAppPadding),
    hasBottomGutter: widget.type !== 'text'
  }, content);
};

exports["default"] = C;
var templateObject_1, templateObject_2, templateObject_3;